module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("Vultures")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A product can be authentic;")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("an object cannot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This presents a problem.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An identity can be authentic;")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("an experience cannot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“How was your sleep experience,”")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("asks Marriott.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Praise or blame")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("is the only legitimate response.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vultures wheel over Miami.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A sign that appears")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("day after day")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("is not a sign.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The library boasts a fine collection")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("of books written in private")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("languages.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Identity is made")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("of select experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you are genuinely sick,")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("the leaves recede")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and the flickering holes between them")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("come forward—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("not angels, but")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("unnamed objects")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c1ee570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Chapter003.vue
// module id = 84
// module chunks = 0